<template>
  <div>
    <topbar
      :titulo="$t('ACADEMICO.CONTRATOS')"
      :subtitulo="$t('ACADEMICO.CONTRATOS_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    />
    <b-row align-v="end" class="mb-3">
      <b-col cols="6">
        <input-select-multiple
          v-model="matriculaSelecionada"
          label="Busque por nome ou código do aluno:"
          :options="listaMatriculas"
          placeholder="Digite ou procure"
          :loading="loadingMatriculas"
          @add="listarContratosPorMatriculaId()"
          @remove="limparListaContratos"
        />
      </b-col>
      <b-col cols="2" class="form-group mb-0" v-if="podeCadastrar">
        <b-button
          variant="info"
          @click="abrirCadastrar"
          :disabled="desabilitaBotaoCadastrar"
        >
          {{ $t('ACADEMICO.NOVO_CONTRATO') }}
        </b-button>
      </b-col>
    </b-row>

    <b-table
      head-variant="light"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      :items="items"
      :fields="campos"
      :tbody-tr-class="retornarClasseLinhaAno"
      show-empty
      striped
      hover
    >
      <template #cell(acoes)="item">
        <b-dropdown
          variant="outline-default"
          v-if="mostrarAcoes && item.item.ano == false"
        >
          <b-dropdown-item
            @click="baixarContrato(item.item)"
            v-if="item.item.tipo !== 'Atividade extraclasse' && podeVisualizar"
          >
            {{ $t('ACADEMICO.DOWNLOAD_CONTRATO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="abrirModalAditivos(item.item)"
            v-if="
              verificarPermissao('AditivoContrato', 'Criar') &&
              item.item.status == 'Ativo'
            "
          >
            {{ $t('ACADEMICO.ADITIVO_DE_CONTRATO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="abrirMotivoCancelamento(item.item)"
            v-if="podeExcluir && item.item.status == 'Cancelado'"
          >
            {{ $t('ACADEMICO.MOTIVO_CANCELAMENTO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="cancelar(item.item)"
            v-if="podeExcluir && item.item.status !== 'Cancelado'"
          >
            {{ $t('ACADEMICO.CANCELAR_CONTRATO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="irParaEditarContrato(item.item)"
            v-if="podeEditar && item.item.status != 'Cancelado'"
          >
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="ativarContrato(item.item)"
            v-if="podeCadastrar && item.item.status == 'Em aprovação'"
          >
            {{ $t('ACADEMICO.ATIVAR_CONTRATO') }}
          </b-dropdown-item>
          <b-dropdown-item
            @click="visualizarContrato(item.item)"
            v-if="podeVisualizar"
          >
            {{ $t('GERAL.VISUALIZAR') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <modal-motivo-cancelamento
      :exibir="mostrarModalMotivoCancelamento"
      @fechar="fecharMotivoCancelamento"
      @atualizar-listagem="listarContratosPorMatriculaId"
      :contratoId="contratoId"
      :motivoCancelamentoContratoId="motivoCancelamentoContratoId"
    />
    <modal-aditivo-contrato
      @fechar="fecharModalAditivos"
      :exibir="mostrarModalAditivos"
      :contratoId="contratoId"
      :matriculaId="matriculaSelecionada.id"
      :nomeAluno="matriculaSelecionada.nome"
      v-if="matriculaSelecionada"
    />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Services:
import ContratosService from '@/common/services/contratos/contratos.service';
import MatriculaService from '@/common/services/matriculas/matriculas.service';
import pdf from '@/common/utils/pdf';

// Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import { InputSelectMultiple } from '@/components/inputs';
import Permissoes from '@/components/mixins/permissoes';
import ModalMotivoCancelamento from '@/views/academico/contratos/components/ModalMotivoCancelamento';
import ModalAditivoContrato from '@/views/academico/contratos/components/ModalAditivoContrato.vue';

export default {
  mixins: [Permissoes],
  components: {
    Topbar,
    InputSelectMultiple,
    ModalMotivoCancelamento,
    ModalAditivoContrato,
  },
  data() {
    return {
      campos: [
        {
          key: 'codigo',
          label: this.$t('GERAL.CODIGO'),
        },
        {
          key: 'status',
          label: this.$t('GERAL.STATUS'),
        },
        {
          key: 'idioma',
          label: this.$t('GERAL.IDIOMA'),
        },
        {
          key: 'tipo',
          label: 'Tipo contrato',
        },
        {
          key: 'descricao',
          label: 'Descrição',
        },
        {
          key: 'turma',
          label: 'Turma',
        },
        {
          key: 'dataCriacao',
          label: 'Data de criação',
        },
        {
          key: 'dataCancelamento',
          label: 'Data de cancelamento',
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
      mostrarModalAditivos: false,
      mostrarModalSelecionarMatricula: false,
      mostrarModalMotivoCancelamento: false,
      items: [],
      informacoesTabela: [],
      total: 0,
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      item: {},
      listaMatriculas: [],
      matriculaSelecionada: null,
      matriculaSelecionadaStatus: 1,
      motivoCancelamentoContratoId: '',
      contratoId: '',
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO_MATRICULAS.CONTRATOS') },
      ],
      loadingMatriculas: false,
    };
  },
  computed: {
    desabilitaBotaoCadastrar() {
      return this.matriculaSelecionada == null;
    },
    mostrarAcoes() {
      return this.podeVisualizar || this.podeExcluir || this.podeEditar;
    },
  },
  mounted() {
    this.listarMatriculasSemPaginacao();
  },
  methods: {
    retornarClasseLinhaAno(item, type) {
      if (!item || type !== 'row') return;
      if (item.ano === true) return 'line-table-custom';
    },

    listarMatriculasSemPaginacao() {
      this.loadingMatriculas = true;
      MatriculaService.listarSemPaginacao()
        .then(({ data }) => {
          this.listaMatriculas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingMatriculas = false;
        });
    },

    listarContratosPorMatriculaId() {
      this.$store.dispatch(START_LOADING);
      ContratosService.buscarPorMatriculaId(
        this.matriculaSelecionada?.id ?? '',
        this.paginacao
      )
        .then((result) => {
          this.items = result.data;
          console.log(this.items)
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    limparListaContratos() {
      this.items = [];
    },

    //AÇOES
    abrirModalAditivos(contrato) {
      this.contratoId = contrato.id;
      this.mostrarModalAditivos = true;
    },

    fecharModalAditivos() {
      this.contratoId = '';
      this.mostrarModalAditivos = false;
    },

    abrirCadastrar() {
      this.$router.push({
        name: 'contratos-formulario',
        query: {
          matriculaId: this.matriculaSelecionada?.id,
        },
      });
    },

    irParaEditarContrato(item) {
      this.$router.push({
        name: 'editar-contrato',
        params: {
          contratoId: item.id,
        },
        query: {
          matriculaId: this.matriculaSelecionada?.id,
        },
      });
    },

    visualizarContrato(item) {
      this.$router.push({
        name: 'visualizar-contrato',
        params: {
          contratoId: item.id,
        },
        query: { matriculaId: this.matriculaSelecionada?.id },
      });
    },

    abrirMotivoCancelamento(item) {
      this.contratoId = item.id;
      this.motivoCancelamentoContratoId = item.motivoCancelamentoContratoId;
      this.mostrarModalMotivoCancelamento = true;
    },

    fecharMotivoCancelamento() {
      this.mostrarModalMotivoCancelamento = false;
    },

    baixarContrato(item) {
      this.$store.dispatch(START_LOADING);
      ContratosService.baixarPDF(item.id)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);

            let blob = new Blob([bytes], { type: 'application/pdf' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Contrato - ${item.codigo} - ${item.descricao} - ${item.tipo}.pdf`;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    cancelar(item) {
      mensagem
        .confirmacao(null, this.$t('ACADEMICO.CONFIRMAR_CANCELAMENTO_CONTRATO'))
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            ContratosService.excluir(item.id)
              .then(() => {
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('CONTRATOS.MENSAGEM_EXCLUIDO')
                );
                mensagem
                  .confirmacao(
                    null,
                    this.$t('ACADEMICO.CONFIRMAR_MOTIVO_CANCELAMENTO')
                  )
                  .then(async (result) => {
                    if (result.value) {
                      this.abrirMotivoCancelamento(item);
                    }
                  });

                this.listarContratosPorMatriculaId();
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },

    ativarContrato(item) {
      mensagem
        .confirmacao(null, this.$t('ACADEMICO.CONFIRMAR_ATIVAR_CONTRATO'))
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);

            ContratosService.ativarContratoPorId(item.id)
              .then(({ data }) => {
                mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
                this.listarContratosPorMatriculaId();
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
  },
};
</script>
